<div *ngIf="chatGuestInfo$ | async">
   <fa-icon
      [fixedWidth]="true"
      class="chat-guest-info-icon sam-center sam-margin-right"
      tooltipClass="tooltip-popup"
      title="{{ guestStatusTranslate$ | async | translate }}"
      [icon]="chatIcon"
      [class]="(chatGuestInfo$ | async).guestStatus.styleClass"
   ></fa-icon>
   <div fxFlex="1 1 auto" class="sam-margin-left sam-hide-overflow">
      <div class="skill" *ngIf="(chatGuestInfo$ | async).chat.skill">
         <samweb-skill-short-info
            [skills]="(chatGuestInfo$ | async).chat.skill.skills"
            [skillConfiguration]="(chatGuestInfo$ | async).chat.skill.skillConfiguration"
         ></samweb-skill-short-info>
      </div>
      <div class="peer-details">
         <div *ngIf="(chatGuestInfo$ | async).chat.peer">
            <!-- need to add width so the overflow works correctly -->
            <div
               class="sam-form-flex-row"
               style="flex: auto; width: 10%"
               *ngIf="(chatGuestInfo$ | async).chat.peer.name"
            >
               <fa-icon [fixedWidth]="true" [icon]="nameIcon"></fa-icon>
               <samweb-text-with-overflow-tooltip [value]="(chatGuestInfo$ | async).chat.peer.name">
               </samweb-text-with-overflow-tooltip>
            </div>
            <div
               class="sam-form-flex-row"
               style="flex: auto; width: 10%"
               *ngIf="(chatGuestInfo$ | async).chat.peer.email"
            >
               <fa-icon [fixedWidth]="true" [icon]="emailIcon"></fa-icon>
               <samweb-text-with-overflow-tooltip [value]="(chatGuestInfo$ | async).chat.peer.email">
               </samweb-text-with-overflow-tooltip>
            </div>
         </div>
         <div class="sam-form-flex-row" *ngIf="(chatGuestInfo$ | async).chat.peer === null">
            {{ 'samwin.chat_dialog.error_handling.no_peer_details' | translate }}
         </div>
      </div>
   </div>
</div>
